/**
 *
 * @class Panorama
 *
 * basic model for a panorama object; basically the meta data for a single panorama.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class Panorama {

  public corridor: string   = '';
  public enabled: boolean   = false;
  public heading: number    = 0;
  public height: number     = 0;
  public id: number         = 0;
  public mile: number       =  0;
  public point: string      = '';
  public stamp: Date        = null;
  public sub: string        = '';
  public timeline: string   = '';
  public uuid: string       = '';
  public x: number          = 0;
  public y: number          = 0;
  public next: Panorama     = null;
  public previous: Panorama = null;
  public left: Panorama     = null;
  public right: Panorama    = null;
  public signature: string  = '';

  /** standard constructor */
  public constructor (init?: Partial<Panorama>) {

    if (init.next && !(init.next instanceof Panorama)) {

      init.next = new Panorama(init.next);
    }

    if (init.previous && !(init.previous instanceof Panorama)) {

      init.previous = new Panorama(init.previous);
    }

    if (init.left && !(init.left instanceof Panorama)) {

      init.left = new Panorama(init.left);
    }

    if (init.right && !(init.right instanceof Panorama)) {

      init.right = new Panorama(init.right);
    }

    Object.assign(this, init);

    this.heading = Number(this.heading);
    this.height  = Number(this.height);
    this.id      = Number(this.id);
    this.mile    = Number(this.mile);
    this.x       = Number(this.x);
    this.y       = Number(this.y);

    if (typeof this.stamp == 'string') {

      this.stamp = new Date(this.stamp);
    }
  }

  /** cast a REST data chunk to a proper Panorama */
  public static from(data: any): Panorama {

    if (typeof data.heading == 'string') {

      data.heading = Number(data.heading);
    }

    if (typeof data.height == 'string') {

      data.height = Number(data.height);
    }

    if (typeof data.mile == 'string') {

      data.mile = Number(data.mile);
    }

    if (typeof data.x == 'string') {

      data.x = Number(data.x);
    }

    if (typeof data.y == 'string') {

      data.y = Number(data.y);
    }

    return new Panorama(data);
  }

}





